'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import { drawMonogram } from '@/utils/design-elements';
import { getPageName } from '@/utils/helpers';
import { type NavItem, NavItemComponent } from './nav-item';
const navItems: readonly NavItem[] = [{
  children: [{
    href: '/donate/uk',
    label: 'United Kingdom',
    side: 'left'
  }, {
    href: '/donate/us',
    label: 'United States',
    side: 'left'
  }, {
    href: '/donate/global',
    label: 'Global',
    side: 'left'
  }],
  href: '/donate/us',
  label: 'Donate',
  side: 'left'
}, {
  children: [{
    href: '/about/rapid-response-operations',
    label: 'RRR',
    side: 'left'
  }, {
    href: '/about/team',
    label: 'Team',
    side: 'left'
  }, {
    href: '/about/mission-vision-values',
    label: 'Mission, Vision & Values',
    side: 'left'
  }],
  href: '/about',
  label: 'About',
  side: 'left'
}, {
  href: '/past-impact',
  label: 'Past Impact',
  side: 'right'
}, {
  href: '/future-impact',
  label: 'Future Impact',
  side: 'right'
}];
const renderNavItems = (items: readonly NavItem[], side: 'left' | 'right'): readonly React.JSX.Element[] => {
  return items.filter(item => item.side === side).map(item => <NavItemComponent item={item} key={item.href} side={side} />);
};
export default function TopAppBar() {
  const $ = _c(14);
  const pathname = usePathname() || "";
  let t0;
  if ($[0] !== pathname) {
    t0 = getPageName(pathname) === "" ? "home" : getPageName(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pageName = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="top-app-bar-cell top-app-bar-utility-row"><ul className="top-app-bar-nav utility-links"><li className="investors"><a className="inline-text-button-link" href="https://thefuturefound.com" rel="noreferrer" target="_blank">thefuturefound.com</a></li></ul></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="top-app-bar-cell top-app-bar-left"><ul className="top-app-bar-nav top-app-bar-nav-primary">{renderNavItems(navItems, "left")}</ul></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = getPageName(pathname) === getPageName("/") ? "page" : undefined;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = drawMonogram({
      size: 128
    });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="top-app-bar-cell top-app-bar-brandmark top-app-bar-brandmark-with-wordmark-and-descriptor"><Link aria-current={t4} aria-label="Link to homepage." className="symbolmark" href="/">{t5}</Link></div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="top-app-bar-cell top-app-bar-right"><ul className="top-app-bar-nav top-app-bar-nav-primary align-right">{renderNavItems(navItems, "right")}</ul></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className="top-app-bar top-app-bar-with-decoration">{t2}{t3}{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== pageName || $[12] !== t8) {
    t9 = <header data-page-name={pageName}>{t8}</header>;
    $[11] = pageName;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
function _temp() {
  document.body.setAttribute("data-is-loaded", "true");
}